<template>
  <v-dialog
    v-model="dialog"
    max-width="560"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="error"
        flat
        small
        :disabled="dialog"
        v-on="on"
      >
        <v-icon left>
          delete
        </v-icon>
        Delete
      </v-btn>
    </template>
    <v-card>
      <form @submit.prevent="onSubmitForm">
        <v-card-title class="headline">
          Deleting {{ item.name }}?
        </v-card-title>
        <v-card-text>This {{ item.name }} company has {{ item.type.length }} type related, deleting this company will not delete related type.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            flat
            @click="dialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="error"
            flat
            :loading="isSubmitting"
            type="submit"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dialog: false,
    isSubmitting: false
  }),
  methods: {
    ...mapActions({
      deleteCompany: 'clientCompanies/deleteCompany',
      getCompanies: 'clientCompanies/getCompanies'
    }),
    onSubmitForm () {
      this.isSubmitting = true
      this.deleteCompany(this.item)
      .then((response) => {
        if (response.status === 204) {
          this.getCompanies({
            page: 1,
            rowsPerPage: 10
          }).then(() => {
            this.dialog = false
            this.isSubmitting = false
          })
        }
      })
    }
  }
}
</script>
